module.exports = __webpack_public_path__ + "img/french-guiana.8b296b78.svg";